"use strict"; // Adds Responsive Embeds to all iframe, objects and video tags
jQuery(document).ready(function() {
    jQuery('.carousel-item').first().addClass('active');
});